import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import * as fromApp from 'src/app/store';
import { map, tap, withLatestFrom, switchMap, catchError, finalize } from 'rxjs/operators';
import { throwError, of } from 'rxjs';
import * as BusinessDetailsActions from '../actions/business-details.actions';
import { environment } from 'src/environments/environment';
import { Store } from '@ngrx/store';
import { AppService } from 'src/app/store/services/app.service';
import { FirmType } from 'src/app/shared/common/common-constants';
import { Router } from '@angular/router';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { PayrollRedirectModalComponent } from 'src/app/shared/payroll-redirect-modal/payroll-redirect-modal.component';

@Injectable()
export class BusinessDetailsEffects {  
  private updatePayrollPopupHeader = 'Update your payroll information';
  private updatePayrollPopupButtonText = 'Update payroll';
  private updatePayrollPopupMessageForOpStartDate = 'By changing the start date of your business operations, please update your payroll information accordingly.';
  private updatePayrollPopupMessageForWorkerStartDate = 'By changing the start date of your worker, please update your worker payroll information accordingly.';

  private updatePayrollPopupMessageForWorkerStartDatePartnership = 'By changing the date the first worker started, you will need to update your payroll information as well.';

  private requestUrlE2E: string = environment.registrationApiUrl + '/api/v1/E2E/BusinessDetails';
  private orgBookUrl: string = environment.registrationApiUrl + '/api/v1/CorporateInfo/SearchByBN';

  private requestUrlE2ESoleProprietor: string = environment.registrationApiUrl + '/api/v1/E2ESoleProp/SolePropBusinessDetails';
  private requestUrlE2EPartner: string = environment.registrationApiUrl + '/api/v1/E2EPartner/PartnerBusinessDetails';  
  private requestUrlE2EHomeOwner: string = environment.registrationApiUrl + '/api/v1/E2EHomeOwner/HomeOwnerBusinessDetails';

  private currentPayload: any;
  private mergedPayload: any;
  private previousWorkerStartDatePartner: any;
  private previousNumberOfWorkersPartner: number=0;

  constructor(
    private appService: AppService,
    private actions$: Actions,
    private store$: Store<fromApp.State.State>,
    private router: Router,
    public modalService: NgbModal
  ) {}

  postBusinessDetailsE2E$ = createEffect(() => this.actions$.pipe(
    ofType( BusinessDetailsActions.SendBusinessDetailsE2E ),
    tap( action => this.getCurrentPayloadE2E(action.payload) ),
    tap( () => this.store$.dispatch(
      fromApp.Actions.LoadApps({payload: 'postBusinessDetailsE2E$'}))), 
    withLatestFrom(this.store$),
    tap(([action, payload]) => { this.mergePayloadE2E(payload.appstate.internetRegistration); }),
    switchMap(([action, payload]) =>
      this.appService.postApp(this.requestUrlE2E, this.mergedPayload)
        .pipe(
          tap(response => console.log('[BusinessDetials postBusinessDetailsE2E$] request response: ' + JSON.stringify(response))),
          // dispatch action to update appstate with new reponse
          tap(response => {
            let isWorkerPayrollRequired = response.tempInfo?.isWorkerPayrollRequired;

            // temp: set to true for corporation path when reg-api is not updated. 
            // After reg-api is updated and can release together with reg-web, remove the code if need to share with other new paths.
            isWorkerPayrollRequired = true; 
            console.log('[BusinessDetials postBusinessDetailsE2E$] request response: corporation path updated isWorkerPayrollRequired in store= ' + isWorkerPayrollRequired);

            this.store$.dispatch(              
              fromApp.Actions.SaveAppStateWithIsWorkerPayrollRequired(
                { payload: {
                    internetRegistration : this.mergeApplicationType(payload.appstate.internetRegistration, response),
                    isWorkerPayrollRequired: isWorkerPayrollRequired
                }}
              )           
            );   
    
            this.redirectToNext(response, isWorkerPayrollRequired, this.updatePayrollPopupMessageForOpStartDate);            
            
          }),
          // dispact action to update current feature state
        map(() => (BusinessDetailsActions.SendBusinessDetailsSuccess({payload: this.currentPayload}))),
          catchError(e => throwError(new Error(JSON.stringify(e)))),
          finalize(() => {
            // dispatch action to remove loader from appstate.loaders
          this.store$.dispatch(fromApp.Actions.LoadAppsSuccess({payload: 'postBusinessDetailsE2E$'}));
          })
        )
    )
  ));

  postBusinessDetailsE2ESoleProprietor$ = createEffect(() => this.actions$.pipe(
    ofType( BusinessDetailsActions.SendBusinessDetailsE2ESoleProprietor ),
    tap( action => this.getcurrentPayloadE2ESoleProprietor(action.payload) ),
    tap( () => this.store$.dispatch(
      fromApp.Actions.LoadApps({payload: 'postBusinessDetailsE2ESoleProprietor$'}))), 
    withLatestFrom(this.store$),
    tap(([action, payload]) => { this.mergePayloadBusinessDetailsE2ESoleProprietor(payload.appstate.internetRegistration); }),
    switchMap(([action, payload]) =>
      this.appService.postApp(this.requestUrlE2ESoleProprietor, this.mergedPayload)
        .pipe(
          tap(response => console.log('[BusinessDetials postBusinessDetailsE2ESoleProprietor$] request response: ' + JSON.stringify(response))),
          // dispatch action to update appstate with new reponse
          tap(response => {
            let isWorkerPayrollRequired = response.tempInfo?.isWorkerPayrollRequired;      
            console.log('[BusinessDetials postBusinessDetailsE2ESoleProprietor$] request response:  isWorkerPayrollRequired in store= ' + isWorkerPayrollRequired);  
            this.store$.dispatch(              
              fromApp.Actions.SaveAppStateWithIsWorkerPayrollRequired(
                { payload: {
                    internetRegistration : this.mergeApplicationType(payload.appstate.internetRegistration, response),
                    isWorkerPayrollRequired: isWorkerPayrollRequired
                }}
              )           
            );   
    
            this.redirectToNext(response, isWorkerPayrollRequired, this.updatePayrollPopupMessageForWorkerStartDate);            
            
          }),
          // dispact action to update current feature state
        map(() => (BusinessDetailsActions.SendBusinessDetailsSuccess({payload: this.currentPayload}))),
          catchError(e => throwError(new Error(JSON.stringify(e)))),
          finalize(() => {
            // dispatch action to remove loader from appstate.loaders
          this.store$.dispatch(fromApp.Actions.LoadAppsSuccess({payload: 'postBusinessDetailsE2ESoleProprietor$'}));
          })
        )
    )
  ));

  postBusinessDetailsE2EPartner$ = createEffect(() => this.actions$.pipe(
    ofType( BusinessDetailsActions.SendBusinessDetailsE2EPartner),
    tap( action => this.getcurrentPayloadE2EPartner(action.payload) ),
    tap( () => this.store$.dispatch(
      fromApp.Actions.LoadApps({payload: 'postBusinessDetailsE2EPartner$'}))), 
    withLatestFrom(this.store$),
    tap(([action, payload]) => { this.mergePayloadBusinessDetailsE2EPartner(payload.appstate.internetRegistration); }),
    switchMap(([action, payload]) =>
      this.appService.postApp(this.requestUrlE2EPartner, this.mergedPayload)
        .pipe(
          tap(response => console.log('[BusinessDetials postBusinessDetailsE2EPartner$] request response: ' + JSON.stringify(response))),
          // dispatch action to update appstate with new reponse
          tap(response => {
            let isWorkerPayrollRequired = response.tempInfo?.isWorkerPayrollRequired;      
            console.log('[BusinessDetials postBusinessDetailsE2EPartner$] request response:  isWorkerPayrollRequired in store= ' + isWorkerPayrollRequired);  
            this.store$.dispatch(              
              fromApp.Actions.SaveAppStateWithIsWorkerPayrollRequired(
                { payload: {
                    internetRegistration : this.mergeApplicationType(payload.appstate.internetRegistration, response),
                    isWorkerPayrollRequired: isWorkerPayrollRequired
                }}
              )           
            );   
    
            this.redirectToNextPartner(response, isWorkerPayrollRequired, this.updatePayrollPopupMessageForWorkerStartDatePartnership, this.previousNumberOfWorkersPartner, this.previousWorkerStartDatePartner);            
            
          }),
          // dispact action to update current feature state
        map(() => (BusinessDetailsActions.SendBusinessDetailsSuccess({payload: this.currentPayload}))),
          catchError(e => throwError(new Error(JSON.stringify(e)))),
          finalize(() => {
            // dispatch action to remove loader from appstate.loaders
          this.store$.dispatch(fromApp.Actions.LoadAppsSuccess({payload: 'postBusinessDetailsE2EPartner$'}));
          })
        )
    )
  ));
  
  postBusinessDetailsE2EHomeOwner$ = createEffect(() => this.actions$.pipe(
    ofType( BusinessDetailsActions.SendBusinessDetailsE2EHomeOwner ),
    tap( action => this.getcurrentPayloadE2EHomeOwner(action.payload) ),
    tap( () => this.store$.dispatch(
      fromApp.Actions.LoadApps({payload: 'postBusinessDetailsE2EHomeOwner$'}))), 
    withLatestFrom(this.store$),
    tap(([action, payload]) => { this.mergePayloadBusinessDetailsE2EHomeOwner(payload.appstate.internetRegistration); }),
    switchMap(([action, payload]) =>
      this.appService.postApp(this.requestUrlE2EHomeOwner, this.mergedPayload)
        .pipe(
          tap(response => console.log('[BusinessDetials postBusinessDetailsE2EHomeOwner$] request response: ' + JSON.stringify(response))),
          // dispatch action to update appstate with new reponse
          tap(response => {
            let isWorkerPayrollRequired = response.tempInfo?.isWorkerPayrollRequired;      
            console.log('[BusinessDetials postBusinessDetailsE2EHomeOwner$] request response:  isWorkerPayrollRequired in store= ' + isWorkerPayrollRequired);  
            this.store$.dispatch(              
              fromApp.Actions.SaveAppStateWithIsWorkerPayrollRequired(
                { payload: {
                    internetRegistration : this.mergeApplicationType(payload.appstate.internetRegistration, response),
                    isWorkerPayrollRequired: isWorkerPayrollRequired
                }}
              )           
            );   
    
            this.redirectToNext(response, isWorkerPayrollRequired, this.updatePayrollPopupMessageForWorkerStartDate);            
            
          }),
          // dispact action to update current feature state
        map(() => (BusinessDetailsActions.SendBusinessDetailsSuccess({payload: this.currentPayload}))),
          catchError(e => throwError(new Error(JSON.stringify(e)))),
          finalize(() => {
            // dispatch action to remove loader from appstate.loaders
          this.store$.dispatch(fromApp.Actions.LoadAppsSuccess({payload: 'postBusinessDetailsE2EHomeOwner$'}));
          })
        )
    )
  ));

  searchBusinessNumber$ = createEffect(() => this.actions$.pipe(
    ofType(BusinessDetailsActions.SearchBusinessNumber),
    withLatestFrom(this.store$),
    tap( () => this.store$.dispatch(
      fromApp.Actions.LoadApps({payload: 'searchBusinessNumber$'}))), // this is for loader icon
    switchMap(([action, payload]) =>
      this.appService.postApp(`${this.orgBookUrl}/?businessNumber=${action.payload.businessNumber}`, action.payload)
        .pipe(
          tap(response => {
            console.log('[BusinessDetials searchBusinessNumber$] request response: ' + JSON.stringify(response))
            if(response.isOrgBookServiceDown){
              console.log('ORGBOOK IS DOWN')
              this.store$.dispatch(BusinessDetailsActions.IsOrgBookServiceDown())
            }
            else{    
              map(response => (BusinessDetailsActions.SearchBusinessNumberSuccess({ payload: response })));
            }
          }),
          map(response => (BusinessDetailsActions.SearchBusinessNumberSuccess({ payload: response }))),
          catchError(e => throwError(new Error(JSON.stringify(e)))),
          finalize(() => {
            // dispatch action to remove loader from appstate.loaders
            this.store$.dispatch(fromApp.Actions.LoadAppsSuccess({payload: 'searchBusinessNumber$'}));
          })
        )
    )
  ));

  clearBusinessNumber$ = createEffect(() =>
    this.actions$.pipe(
      ofType(BusinessDetailsActions.ClearBusinessNumber),
      tap(() => { }),
      switchMap(() =>
        of(BusinessDetailsActions.ClearBusinessNumberSuccess()) // Return the custom action instead of void
      )
    )
  );

  private mergeApplicationType(internetRegistration: any, response: any) {
    return {
      ...response,
      accountType: internetRegistration.accountType
    };
  }  

  private isOperationStartDateChanged(oldOPStartDate: string, newOPStartDate: string, firmType: FirmType): boolean {    

    let checkOPStartDateChanged = false;

    switch ( firmType ) {
      case FirmType.limitedCompany:
      case FirmType.association:
      case FirmType.band:
      case FirmType.church:
      case FirmType.cooperative:
      case FirmType.society:
      case FirmType.union:
        checkOPStartDateChanged = true;
        break;
    }

    if (!checkOPStartDateChanged) {
      return false;
    }  

    if (oldOPStartDate === undefined) {
      oldOPStartDate = null;
    }
    if (newOPStartDate === undefined) {
      newOPStartDate = null;
    }

    const changed = (oldOPStartDate !== newOPStartDate) ? true : false;
    console.log('[BusinessDetailsEffects] checkIsOPStartDateChanged: ' +
    ' oldOPStartDate=' + oldOPStartDate + ' newOPStartDate=' + newOPStartDate + ' changed=' + changed );
    return changed;
  }

  trimLegalNameIfExceedsLimit(legalName: any): string {
    // null and '' different in IREG_IsDuplicateIREGLegalName
    if (legalName !== null) {     
      if (legalName.length > 63) {
        return legalName.substring(0, 63);
      }
    }
    return legalName;
  }

  //E2E  
  private getCurrentPayloadE2E(payload: any) {    
    this.currentPayload = {    
      businessDetailsInfo: payload.businessDetailsInfo,
      accountType: payload.accountType,
      firmType: payload.firmType,
      redirectUrl: payload.redirectUrl,
      payrollUrl: payload.payrollUrl
    };
    console.log('[BusinessDetailsEffects] getCurrentPayloadE2E current payload: ' + JSON.stringify(this.currentPayload));
  }

  private mergePayloadE2E(internetRegistration: any): any {
    console.log('[BusinessDetailsEffects] mergePayloadE2E merging current participation');   
    internetRegistration.accountType = this.currentPayload.accountType;
    internetRegistration.firmType = this.currentPayload.firmType;
    this.mergedPayload = {  
      iRegReferenceNumber : internetRegistration?.registrationSession?.iRegReferenceNumber,
      accountType : this.currentPayload.accountType,
      firmType : this.currentPayload.firmType,      
      businessDetailsInfoPage: this.currentPayload.businessDetailsInfo,
      isReviewVisited: internetRegistration?.userChoice?.isReviewVisited
    };
    return this.mergedPayload;
  } 

  private redirectToNext(iReg: any, isWorkerPayrollRequired: boolean, message: string) {
    try {
      if (iReg.userChoice.isReviewVisited && isWorkerPayrollRequired) {
        const numberOfWorkers = iReg.eligibility?.eligibilityResponseSet1?.registeredWorkerCount;   
        const workerStartDt = iReg.eligibility?.eligibilityResponseSet1?.workerStartDate;        
        const workerPayrollList = iReg.payroll.filter(payroll => payroll.payrollTypeCD == 'W');
        console.log('[BusinessDetailsEffects] redirectToNext  workerStartDt=' + workerStartDt);      

        let showPopUp = false;
        if (numberOfWorkers > 0 && workerPayrollList && workerPayrollList.length == 0) {
          showPopUp = true;
        }      

        if (showPopUp) {
            this.getConfirmation(message).then(x => {
              this.router.navigateByUrl(this.currentPayload.payrollUrl);
            });
        }    

      }      
    } catch(ex) {
        console.log('redirectToNext ex=' + ex.message);
    }   

    if (this.currentPayload.redirectUrl && this.currentPayload.redirectUrl != '') {
      this.router.navigateByUrl(this.currentPayload.redirectUrl); 
    }    
  }

  private redirectToNextPartner(iReg: any, isWorkerPayrollRequired: boolean, message: string, previousNumberOfWorkers: number, previousWorkerStartDate: string) {
    try {
      if (iReg.userChoice.isReviewVisited && isWorkerPayrollRequired) {
        const numberOfWorkers = iReg.eligibility?.eligibilityResponseSet1?.registeredWorkerCount;   
        const workerStartDt = iReg.eligibility?.eligibilityResponseSet1?.workerStartDate;        
        const workerPayrollList = iReg.payroll.filter(payroll => payroll.payrollTypeCD == 'W');       
                    
        let showPopUp = false;
        if (numberOfWorkers != previousNumberOfWorkers || 
            numberOfWorkers > 0 && workerPayrollList && workerPayrollList.length == 0) {
          showPopUp = true;
        }     

        try {            
          if (!showPopUp && previousWorkerStartDate != null) {
            const previousDate = previousWorkerStartDate.length > 10 ? previousWorkerStartDate.substring(0, 10) : previousWorkerStartDate;
            const currentDate = workerStartDt != null && workerStartDt.length > 10? workerStartDt.substring(0, 10) : workerStartDt;
            if (previousDate !== currentDate) {
              showPopUp = true;
            }  
          }             
        } catch(ex0) {
            console.log('redirectToNextPartner previousWorkerStartDate ex0=' + ex0.message);
        }  

        console.log('[BusinessDetailsEffects] redirectToNextPartner previousNumberOfWorkers=' +  previousNumberOfWorkers + 
          ' previousWorkerStartDate=' +  previousWorkerStartDate + ' workerStartDt=' + workerStartDt + ' showPopUp=' + showPopUp);


        if (showPopUp) {
            this.getConfirmation(message).then(x => {
              this.router.navigateByUrl(this.currentPayload.payrollUrl);
            });
        }    

      }      
    } catch(ex) {
        console.log('redirectToNext ex=' + ex.message);
    }   

    if (this.currentPayload.redirectUrl && this.currentPayload.redirectUrl != '') {
      this.router.navigateByUrl(this.currentPayload.redirectUrl); 
    }    
  }
  

  private getConfirmation(message: string): Promise<boolean> {
    const config: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      windowClass: 'registration-modal medium-modal'
    };
    const modal = this.modalService.open(PayrollRedirectModalComponent, config);
    modal.componentInstance.header = this.updatePayrollPopupHeader;
    modal.componentInstance.buttonText = this.updatePayrollPopupButtonText;
    modal.componentInstance.message = message;    
    return modal.result;
  }

  //E2ESoleProprietor
  private getcurrentPayloadE2ESoleProprietor(payload: any) {    
    this.currentPayload = {    
      businessDetailsInfo: payload.businessDetailsInfo,
      accountType: payload.accountType,
      firmType: payload.firmType,
      redirectUrl: payload.redirectUrl,
      payrollUrl: payload.payrollUrl
    };
    console.log('[BusinessDetailsEffects] getCurrentPayloadE2E SoleProprie to current payload: ' + JSON.stringify(this.currentPayload));
  }

  private mergePayloadBusinessDetailsE2ESoleProprietor(internetRegistration: any): any {
    console.log('[BusinessDetailsEffects] mergePayloadE2E SoleProprie to merging current participation');   
    internetRegistration.accountType = this.currentPayload.accountType;
    internetRegistration.firmType = this.currentPayload.firmType;
    this.mergedPayload = {  
      iRegReferenceNumber : internetRegistration?.registrationSession?.iRegReferenceNumber,
      accountType : this.currentPayload.accountType,
      firmType : this.currentPayload.firmType,      
      businessDetailsInfoPageSoleProp: this.currentPayload.businessDetailsInfo,
      isReviewVisited: internetRegistration?.userChoice?.isReviewVisited
    };
    return this.mergedPayload;
  } 
  
 
  //E2EPartner
  private getcurrentPayloadE2EPartner(payload: any) {    
    this.currentPayload = {    
      businessDetailsInfo: payload.businessDetailsInfo,
      accountType: payload.accountType,
      firmType: payload.firmType,
      redirectUrl: payload.redirectUrl,
      payrollUrl: payload.payrollUrl
    };
    console.log('[BusinessDetailsEffects] getCurrentPayloadE2E SoleProprie to current payload: ' + JSON.stringify(this.currentPayload));
  }

  private mergePayloadBusinessDetailsE2EPartner(internetRegistration: any): any {
    console.log('[BusinessDetailsEffects] mergePayloadE2E SoleProprie to merging current participation');   
    internetRegistration.accountType = this.currentPayload.accountType;
    internetRegistration.firmType = this.currentPayload.firmType;
    this.mergedPayload = {  
      iRegReferenceNumber : internetRegistration?.registrationSession?.iRegReferenceNumber,
      accountType : this.currentPayload.accountType,
      firmType : this.currentPayload.firmType,      
      businessDetailsInfoPagePartner: this.currentPayload.businessDetailsInfo,
      isReviewVisited: internetRegistration?.userChoice?.isReviewVisited
    };
    this.previousWorkerStartDatePartner = internetRegistration?.eligibility?.eligibilityResponseSet1?.workerStartDate;
    this.previousNumberOfWorkersPartner = internetRegistration?.eligibility?.eligibilityResponseSet1?.registeredWorkerCount;
    return this.mergedPayload;
  } 
  
 
  //E2EHomeOwner
  private getcurrentPayloadE2EHomeOwner(payload: any) {    
    this.currentPayload = {    
      businessDetailsInfo: payload.businessDetailsInfo,
      accountType: payload.accountType,
      firmType: payload.firmType,
      redirectUrl: payload.redirectUrl,
      payrollUrl: payload.payrollUrl
    };
    console.log('[BusinessDetailsEffects] getCurrentPayloadE2E HomeOwner to current payload: ' + JSON.stringify(this.currentPayload));
  }

  private mergePayloadBusinessDetailsE2EHomeOwner(internetRegistration: any): any {
    console.log('[BusinessDetailsEffects] mergePayloadE2E HomeOwner to merging current participation');   
    internetRegistration.accountType = this.currentPayload.accountType;
    internetRegistration.firmType = this.currentPayload.firmType;
    this.mergedPayload = {  
      iRegReferenceNumber : internetRegistration?.registrationSession?.iRegReferenceNumber,
      accountType : this.currentPayload.accountType,
      firmType : this.currentPayload.firmType,      
      businessDetailsInfoPageHomeOwner: this.currentPayload.businessDetailsInfo,
      isReviewVisited: internetRegistration?.userChoice?.isReviewVisited
    };
    return this.mergedPayload;
  }  
}
